/*
  OLG gift sync
  Each gifted card carries a hidden property _olg_gift_id, and its Gift service fee line
  carries the same value in _olg_gift_for. Whenever the bag changes (and on page load),
  any fee line whose card is gone is removed, so customers never pay for a gift with no card.
*/
(function () {
  if (!window.routes) return;
  var busy = false;

  function refreshBubble() {
    return fetch(window.location.pathname + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var el = document.getElementById('cart-icon-bubble');
        if (!el) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.shopify-section');
        if (section) el.innerHTML = section.innerHTML;
      });
  }

  function sync() {
    if (busy) return;
    busy = true;
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cardIds = {};
        cart.items.forEach(function (item) {
          var id = item.properties && item.properties._olg_gift_id;
          if (id) cardIds[id] = true;
        });
        var updates = {};
        var count = 0;
        cart.items.forEach(function (item) {
          var forId = item.properties && item.properties._olg_gift_for;
          if (forId && !cardIds[forId]) {
            updates[item.key] = 0;
            count++;
          }
        });
        if (!count) return;
        return fetch(window.routes.cart_update_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }).then(function () {
          var drawer = document.querySelector('cart-drawer');
          if (window.location.pathname === window.routes.cart_url || (drawer && drawer.classList.contains('active'))) {
            window.location.reload();
          } else {
            return refreshBubble();
          }
        });
      })
      .catch(function (e) { console.error('OLG gift sync', e); })
      .finally(function () { busy = false; });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(sync, 300); });
  }
})();
